import styled from "styled-components";

export const WrapperButton = styled.button`
  background: none;
  border: none;
  outline: none;
  padding: 0;
  line-height: 1;
  cursor: pointer;
`;
